import { getBanner,engineGame,getEngineMedia } from '@/api/init'
export default {
    state: {
        bannarList: [],
        engineGameList: [],
        engineMediaList: [],
        // 专区游戏
        speciallyGameList:{
            list1:[],
            list2:[],
            list3:[],
            list4:[],
        },
    },

    mutations: {
        setBannerList(state, data) {
            state.bannarList = data
        },
        setEngineGameList(state, data) {
            state.engineGameList = data
        },
        setEngineMediaList(state, data) {
            state.engineMediaList = data
        },
        setSpeciallyGameList(state,{name,data}) {
            state.speciallyGameList[name] = data
        },
    },

    actions: {
        initActions({ dispatch }) {
            dispatch('getBannerList')
            dispatch('getEngineGameList')
            dispatch('getEngineMediaList')
            dispatch('getSpeciallyGameList')
        },
        async getBannerList({ commit }) {
            let { code, data } = await getBanner({ scene: 2 })
            commit('setBannerList', data)

        },
        async getEngineGameList({ commit }) {
            let { code, data } = await engineGame({ scene: 1 })
            commit('setEngineGameList', data)
        },
        async getEngineMediaList({ commit }) {
            let { code, data } = await getEngineMedia()
            commit('setEngineMediaList', data)
        },
        async getSpeciallyGameList({ commit }) {
            let arr = [
                {name:'list1',params:{scene:2,game_tag:1}},
                {name:'list2',params:{scene:2,game_tag:2}},
                {name:'list3',params:{scene:2,game_tag:3}},
                {name:'list4',params:{scene:3}}
            ]
            // commit('setSpeciallyGameList', {name:'list',data:[]})
            arr.forEach(async(item,index)=>{
                let { code, data } = await engineGame(item.params)
                commit('setSpeciallyGameList', {name:item.name,data})
            })
        },
    },
};
